// extracted by mini-css-extract-plugin
export default {"clientInformation":"k9OGM___ClientInformation-module__clientInformation","clientLogo":"WJ8WH___ClientInformation-module__clientLogo"};